import type { CustomCellRendererProps } from '@cmg/data-grid';
import { Box, Stack, Tooltip } from '@cmg/design-system';
import { useMemo } from 'react';

import type { InvestorFirmFragment } from '../graphql/__generated__';
import { getSalesCoverageNames } from './sales-coverage.model';

type SalesCoverageCellRendererProps = Readonly<
  CustomCellRendererProps<InvestorFirmFragment, InvestorFirmFragment['salesCoverage']>
>;

export function SalesCoverageCellRenderer({
  value,
  valueFormatted,
}: SalesCoverageCellRendererProps) {
  const names = useMemo(() => getSalesCoverageNames(value), [value]);

  return (
    <Tooltip
      variant="info"
      placement="top"
      title={
        names.length > 1 && (
          <Stack>
            {names.map((name, index) => (
              <Box key={`${name}-${index}`}>{name}</Box>
            ))}
          </Stack>
        )
      }
    >
      <span>{valueFormatted}</span>
    </Tooltip>
  );
}
